var _excluded = ["id", "className"];

var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
import { useField } from 'formik';
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  --border-color: #138A89;\n\n  position: relative;\n  display: inline-block;\n  min-width: 16px;\n  height: 16px;\n  border: 1px solid var(--border-color);\n  cursor: pointer;\n  background-color: var(--white);\n\n  &.active {\n    &::after {\n      --borderWidth: 1px;\n      --height: 9px;\n      --width: 5px;\n\n      content: \"\";\n      position: absolute;\n      left: 5px;\n      top: 1px;\n      display: inline-block;\n      transform: rotate(45deg);\n      height: var(--height);\n      width: var(--width);\n      border-bottom: var(--borderWidth) solid var(--border-color);\n      border-right: var(--borderWidth) solid var(--border-color);\n    }\n  }\n\n  &.error {\n    --border-color: var(--red);\n    background-color: rgba(255, 98, 126, 0.12);\n  }\n\n  input { display: none; }\n"])));
var Checkbox = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var type = 'checkbox';
  var innerRef = React.useRef(ref);

  var _useField = useField(_extends({
    type: type
  }, props)),
      field = _useField[0],
      meta = _useField[1];

  var error = meta.touched && meta.error;

  var onClick = function onClick(e) {
    e.preventDefault();
    innerRef.current.click();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    className: cx(className, {
      active: field.checked,
      error: !!error
    }),
    onClick: onClick
  }), /*#__PURE__*/React.createElement("input", _extends({
    className: "d-none invisible",
    ref: innerRef
  }, props, field, {
    type: type
  })));
});
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  className: PropTypes.string
} : {};
export default Checkbox;